var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"border-2 d-flex text-black",attrs:{"show":"","variant":"white"}},[_c('b-icon',{staticClass:"flex-grow-0 pr-3",attrs:{"icon":"info-circle"}}),_c('div',{staticClass:"font-condensed"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }